import type { PolygonEntityType, CheckoutZoneType } from '../app/appContext';

/** All polygon entity types that represent checkout zones */
export const CHECKOUT_ENTITY_TYPES: PolygonEntityType[] = ['queue', 'cashier', 'staff', 'order_waiting'];

/** Map polygon entity type → backend checkout zone type */
export const ENTITY_TO_CHECKOUT_TYPE: Partial<Record<PolygonEntityType, CheckoutZoneType>> = {
  queue: 'QUEUE',
  cashier: 'CASHIER',
  staff: 'STAFF',
  order_waiting: 'ORDER_WAITING',
};

/** Map backend checkout zone type → polygon entity type */
export const CHECKOUT_TYPE_TO_ENTITY: Record<CheckoutZoneType, PolygonEntityType> = {
  QUEUE: 'queue',
  CASHIER: 'cashier',
  STAFF: 'staff',
  ORDER_WAITING: 'order_waiting',
};

/** Toolbar mode → entity type mapping */
export const MODE_TO_TYPE: Record<string, PolygonEntityType> = {
  create_standalone: 'standalone',
  create_rack: 'rack',
  create_shelf: 'shelf',
  create_table: 'table',
  create_queue: 'queue',
  create_cashier: 'cashier',
  create_staff: 'staff',
  create_order_waiting: 'order_waiting',
};

/** All type options for the type selector UI */
export const TYPE_OPTIONS: { value: PolygonEntityType; label: string }[] = [
  { value: 'standalone', label: 'Одиночная зона' },
  { value: 'rack', label: 'Стеллаж' },
  { value: 'shelf', label: 'Секция' },
  { value: 'table', label: 'Стол' },
  { value: 'queue', label: 'Очередь' },
  { value: 'cashier', label: 'Касса' },
  { value: 'staff', label: 'Рабочая зона' },
  { value: 'order_waiting', label: 'Зона ожидания' },
];

/** Color scheme for polygon rendering */
export const POLYGON_COLORS: Record<PolygonEntityType, string> = {
  standalone: '#FFD600',
  rack: '#2196F3',
  shelf: '#F44336',
  table: '#4CAF50',
  queue: '#FF9800',
  cashier: '#9C27B0',
  staff: '#00BCD4',
  order_waiting: '#795548',
};

/** Human-readable zone type labels (Russian) */
export const TYPE_LABELS: Record<PolygonEntityType, string> = {
  standalone: 'Одиночная зона',
  rack: 'Стеллаж',
  shelf: 'Секция',
  table: 'Стол',
  queue: 'Очередь',
  cashier: 'Касса',
  staff: 'Рабочая зона',
  order_waiting: 'Зона ожидания',
};

/** Types that require exactly 4 points */
export const FOUR_POINT_TYPES: PolygonEntityType[] = ['rack', 'shelf', 'table'];

/** Whether an entity type requires exactly 4 points */
export function isFourPointType(type: PolygonEntityType): boolean {
  return FOUR_POINT_TYPES.includes(type);
}

/**
 * Projected (perspective-warped) polygons: they share the top-left/clockwise
 * 4-point tip, the perspective_width/height fields, the crop preview, and the
 * recalc button. Identical set to FOUR_POINT_TYPES — aliased for intent.
 */
export const PROJECTED_TYPES = FOUR_POINT_TYPES;
export function isProjectedType(type: PolygonEntityType): boolean {
  return isFourPointType(type);
}

/** Whether an entity type is a checkout zone type */
export function isCheckoutType(type: PolygonEntityType): boolean {
  return CHECKOUT_ENTITY_TYPES.includes(type);
}
